import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {CompetitorPlayerStatsModuleStatsScrolledEvent} from "../../models/analytics/competitor-player-stats-module.stats-scrolled.event";

export class CompetitorPlayerStatsModuleStatsScrolledEventHandler extends AnalyticsEventHandler {
  type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.statsScrolledHandler;
  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitorPlayerStatsModuleStatsScrolledEvent;
  }
}
